import { Controller } from "@hotwired/stimulus"
import sortable from "html5sortable/dist/html5sortable.es.js"
import { initializeCarousels } from "../../../external/carousel_initializer"

// Connects to data-controller="editor--multi-slider--reorder"
export default class extends Controller {
  static values = {
    url: String,
  }

  connect() {
    sortable(this.element, {
      items: ".sortable-slide-inapp",
      handle: ".handle",
      placeholderClass: "multi-slider-placeholder",
    })

    this.element.addEventListener("sortupdate", this.handleSortUpdate)
    this.element.addEventListener("sortstart", this.handleDragStart)
    this.element.addEventListener("sortstop", this.handleDragEnd)
  }

  disconnect() {
    sortable(this.element, "destroy")
    this.element.removeEventListener("sortupdate", this.handleSortUpdate)
    this.element.removeEventListener("sortstart", this.handleDragStart)
    this.element.removeEventListener("sortstop", this.handleDragEnd)
  }

  // Save carousel styles before drag starts. Slider.destroy() calls
  // removeAttribute('style') which strips server-set inline styles
  // (height, width, z-index). The destroy may happen during the drag
  // via Stimulus disconnect (from html5sortable's replaceWith), so we
  // must capture styles before any of that.
  handleDragStart = () => {
    this.element.dataset.reordering = "true"
    this._carouselStyles = new Map()
    this.element.querySelectorAll(".carousel").forEach((carousel) => {
      this._carouselStyles.set(carousel.id, carousel.getAttribute("style"))
    })
  }

  // After drag, reinitialize carousels with their original styles restored.
  handleDragEnd = () => {
    this.element.querySelectorAll(".carousel").forEach((carousel) => {
      if (!window.carousels) return

      for (let i = window.carousels.length - 1; i >= 0; i--) {
        if (window.carousels[i].selector === carousel) {
          if (carousel.contains(window.carousels[i].sliderFrame)) {
            window.carousels[i].destroy()
          }
          window.carousels.splice(i, 1)
        }
      }

      // Restore original styles (height, width, z-index) before reinit
      const savedStyle = this._carouselStyles?.get(carousel.id)
      if (savedStyle) {
        setTimeout(() => {
          carousel.setAttribute("style", savedStyle)
        }, 0)
      }
      carousel.dataset.carouselInitialized = "false"
    })
    this._carouselStyles = null
    initializeCarousels(".carousel", this.element)
    // Delay removing the flag — inapp-partial#disconnect fires after sortstop
    // and needs the flag to skip its carousel destroy
    setTimeout(() => { delete this.element.dataset.reordering }, 100)
  }

  handleSortUpdate = (e) => {
    this.updateSlidesOrder(e.detail.destination.items)
  }

  updateSlidesOrder(items) {
    const slides = items
      .map((item) => item.dataset.slideId)
      .filter(Boolean)

    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.head.querySelector(`meta[name="csrf-token"]`)?.getAttribute("content"),
      },
      body: JSON.stringify({ slides }),
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html))
  }
}
